// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3JMhG","savePackageButton":"ClientWallet_savePackageButton__3xVhM"};